import { BarChart } from "@mui/icons-material";
import { Box, Button, Grid, IconButton, Tooltip } from "@mui/material";
import ExplorerGrid, { useExplorerGrid } from "common/ExplorerGrid";
import { Can } from "context/permissionContenxt";
import PageNotFound from "pages/PageNotFound";
import Cube from "qubCommon/CubeStats/Cube";
import useToolbarProps from "qubCommon/ExplorerToolbar/useToolbarProps";
import { Dropdown, TextInput } from "qubCommon/Inputs";
import { useEffect, useState } from "react";
import { treeItems } from "./treeItems";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const ApplicationsExplorer = () => {
  const [showStatistics, setShowStatistics] = useState(false);
  const [statisticsData, setStatisticsData] = useState([]);
  const [statisticsColumns, setStatisticsColumns] = useState([]);
  const [contextMenuIds, setContextMenuIds] = useState({});

  const navigate = useNavigate();

  const { status, critParams, ...toolbarRest } = useToolbarProps({
    webPageKey: "Applications-Expl",
    hideAddNew: true,
  });

  const handlePopup = (currentItem) => {
    if (currentItem?.RedirectTo === 'student-application')
      setContextMenuIds({
        applicationId: currentItem?.Id,
        applicationRenderOptions: currentItem?.RedirectTo

      })
    else {
      setContextMenuIds({
        applicationId: currentItem?.Id,
        applicationRenderOptions: currentItem?.RedirectTo ?? 'application'

      })
    }

  };

  const handleNavigate = (item, newWindow = false) => {

    // if (item?.RedirectTo === 'student-application') {
    //   window.alert('O έλεγχος της αίτησης του Προγράμματος 6 δεν είναι ακόμη διαθέσιμος.')
    //   return;
    // }

    if (newWindow) window.open(`/lae-miteres/${item?.RedirectTo ?? 'application'}/${item?.Id}`, '_blank');
    else navigate(`/${item?.RedirectTo ?? 'application'}/${item?.Id}`);
  };

  const { explParams, ...explorerRest } = useExplorerGrid({
    explorerDataKey: "Applications-Expl",
    xlsxName: "Applications",
    status,
    onPopup: handlePopup,
    onSelect: handleNavigate
  });

  useEffect(() => {
    const storageData = localStorage.getItem(`extraParams_Applications-Expl`);
    if (storageData) {
      explorerRest?.form.setValue(
        "searchFieldValue",
        JSON.parse(storageData)?.searchFieldValue
      );
      let childCategory;
      try {
        childCategory = JSON.parse(storageData)?.ChildCategory;
      } catch (e) {
        console.log(e);
      }
      if (childCategory)
        explorerRest?.form?.setValue("ChildCategory", childCategory);
      else explorerRest?.form?.setValue("ChildCategory", "0");
      let updatedBy;
      try {
        updatedBy = JSON.parse(storageData)?.UpdatedById;
      } catch (e) {
        console.log(e);
      }
      if (updatedBy) explorerRest?.form?.setValue("UpdatedById", updatedBy);
      else explorerRest?.form?.setValue("UpdatedById", "0");
    } else {
      explorerRest?.form?.setValue("ChildCategory", "0");
      explorerRest?.form?.setValue("UpdatedById", "0");
    }
  }, []);

  const handleShowStatistics = async () => {
    const helpCols = [];
    const { initColumns } = toolbarRest;
    if (initColumns?.length > 0)
      initColumns.forEach((column) =>
        column.children.forEach((child) =>
          helpCols.push({
            binding: child?.fldName,
            header: child?.fldTitle,
            visible: child?.isVisible,
            format: child?.fldFormat,
            position: child?.fldPosition,
            width: child?.colWidth ?? "*",
            align: child?.colAlign ?? "center",
            multiline: child?.multiline,
          })
        )
      );
    setShowStatistics(true);
    setStatisticsData(explorerRest?.gridData?.items);
    setStatisticsColumns(helpCols);
  };

  const handleHideStatistics = async () => {
    setShowStatistics(false);
    setStatisticsData([]);
    setStatisticsColumns([]);
  };



  // Usage


  return (
    <>
      <Can I="View" a="GovnrApplications">
        <div
          style={{
            margin: 20,
            padding: 20,
            borderRadius: 8,
            backgroundColor: "#f3f3f3",
          }}
        >
          {showStatistics ? (
            <Cube
              data={statisticsData}
              columns={statisticsColumns}
              onClose={() => setShowStatistics(false)}
              hideStatistics={handleHideStatistics}
              treeItems={treeItems}
            />
          ) : (
            <ExplorerGrid
              explParams={explParams}
              title="Applications"
              breadcrumbs={[
                { name: "Applications", path: "govnr/Applications" },
              ]}
              hideAscendingRowNumber
              autoRowHeights
              // buttons={
              //   <Box boxShadow={2} sx={{ borderRadius: 50 }}>
              //     <Tooltip title="Στατιστικα" onClick={handleShowStatistics}>
              //       <IconButton>
              //         <BarChart />
              //       </IconButton>
              //     </Tooltip>
              //   </Box>
              // }
              contextMenuIds={contextMenuIds}

              {...explorerRest}
              {...toolbarRest}
            // cleanFilters={<Button
            //   variant='contained'
            //   color='error'
            //   sx={{ marginLeft: 1 }}
            //   onClick={removeLocalStorageItems}
            // >
            //   Επαναφορά Φίλτρων
            // </Button>}
            >
              <Grid item xs={12} md={6} lg={3}>
                <TextInput
                  id="Search"
                  name="searchFieldValue"
                  label={"Αναζήτηση"}
                  placeholder={"Αναζήτηση"}
                />
              </Grid>
              {toolbarRest?.lookups?.map((lk) => {
                return (
                  <Grid key={lk.value} item xs={12} md={6} lg={3}>
                    <Dropdown
                      id={lk.value}
                      name={lk.value}
                      label={lk.title}
                      options={lk?.children}
                      labelName="title"
                      valueName="value"
                    />
                  </Grid>
                );
              })}
            </ExplorerGrid>
          )}
        </div>
      </Can>
      <Can not I="View" a="GovnrApplications">
        <PageNotFound />
      </Can>
    </>
  );
};
export default ApplicationsExplorer;
